<script>
import rappiUtils from '@/mixins/utils.js'
import deepLink from '@/mixins/deeplink.js'
import { widgetActions } from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownPhoneNumberItem',
  mixins: [rappiUtils(), deepLink()],
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('widgets', ['widget']),
  },
  methods: {
    ...widgetActions,
    callRestaurant: function () {
      this.callPhone(this.phoneNumber)
    },
  },
}
</script>

<template>

  <div :class="$style.container">

    <p
      :class="$style.container__text"
      @click="callRestaurant"
    >
      {{ phoneNumber }}
    </p>

    <div :class="$style.container__imageWrapper">
      <img
        :class="$style.container__image"
        src="@assets/images/phone.svg"
        @click="callRestaurant"
      >
    </div>

  </div>
</template>

<style scoped module lang="scss">
@import '@design';
.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  border-bottom: 1px solid $divider-gray;

  &__text {
    @extend %typography-medium;

    margin: 0;
    font-weight: 500;
    color: $secondary-text;
    margin-left: 0.3rem;
  }

  &__imageWrapper {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;

    width: 2.5rem;
    height: 2.5rem;
    margin-left: 0.5rem;
    background-color: $options-color;
    border-radius: 50%;
  }
}
</style>
